import * as style from './style.module.css';

const Row = ({ children, className = '', ...props }) => (
    <tr className={`${style.row} ${className}`} {...props}>
        {children}
    </tr>
);

export default Row;
